<h1 mat-dialog-title class="strong">Etykiety ({{ parentName }})</h1>
<mat-dialog-content>
  <div [formGroup]="form" class="flex flex-col">
    <mat-form-field appearance="outline">
      <input
        matInput
        formControlName="tagName"
        maxlength="30"
        [appInputMaxLength]="30"
        placeholder="Wpisz nazwę etykiety"
      />

      <mat-hint align="end"> {{ form.get('tagName').value?.length || 0 }} / 30</mat-hint>
    </mat-form-field>
  </div>

  <div class="tag-list" *ngIf="!form.tagName.value">
    <div *ngFor="let tag of tags">
      <app-tag-list-item
        [tag]="tag"
        [customerBillerId]="customerBillerId"
        [subAccountId]="subAccountId"
        [checkChange]="checkChange"
        (edit)="edit(tag)"
      >
      </app-tag-list-item>
    </div>
  </div>

  <div class="tag-list" *ngIf="filteredTags && filteredTags.length > 0">
    <div *ngFor="let tag of filteredTags">
      <app-tag-list-item
        [tag]="tag"
        [customerBillerId]="customerBillerId"
        [subAccountId]="subAccountId"
        [checkChange]="checkChange"
        (edit)="edit(tag)"
      ></app-tag-list-item>
    </div>
  </div>

  <div
    *ngIf="form.tagName?.value"
    class="flex flex-row items-center add-tag-area"
    (click)="addCustomTag(form.tagName.value)"
  >
    <app-icon name="add" class="pl-8 pr-12"></app-icon>
    <span>Dodaj "{{ form.tagName.value }}"</span>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="start">
  <ng-container *ngIf="!form.tagName?.value">
    <button mat-raised-button color="accent" *ngIf="closeAction === closeActionEnum.SAVE" [matDialogClose]="true">
      Zapisz
    </button>
    <button mat-raised-button color="accent" *ngIf="closeAction === closeActionEnum.CLOSE" [matDialogClose]="false">
      Zamknij
    </button>
  </ng-container>
  <button mat-raised-button color="accent" *ngIf="form.tagName?.value" (click)="cancel()">Zamknij</button>
</mat-dialog-actions>
